import React from 'react';

/**
 * Card-esqueleto do carregamento de um radar (transversal/at-82).
 *
 * Ocupa o lugar exato de um card real, com shimmer nas linhas e um spinner no lugar do número —
 * em vez de uma frase solta na tela. `aria-hidden` porque o estado de carregamento é anunciado
 * pelo container (`role="status"`), não por cada placeholder.
 *
 * Existia duas vezes por cópia (a página do Financeiro e o painel do Relacionamento), com uma
 * linha de diferença entre elas. Aqui é um só; quem quiser o esqueleto mais curto usa `curto`.
 */
const EsqueletoDeCard: React.FC<{ curto?: boolean }> = ({ curto = false }) => (
  <article className="do-card radar-card radar-esqueleto" aria-hidden="true">
    <div className="radar-esqueleto-linha radar-esqueleto-titulo" />
    <div className="radar-esqueleto-numero">
      <span className="radar-spinner" />
    </div>
    <div className="radar-esqueleto-linha" />
    {!curto && <div className="radar-esqueleto-linha radar-esqueleto-curta" />}
    <div className="radar-esqueleto-linha radar-esqueleto-botao" />
  </article>
);

export default EsqueletoDeCard;
